var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommSkype(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#0078D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M87 226a171 171 0 0 0 199 199c109 53 185-64 139-139 23-132-98-220-199-199A102 102 0 0 0 87 226m241-42c16 23-16 41-28 27-16-18-32-27-49-26-44 3-43 40-5 45 52 8 99 22 95 68-5 52-47 67-90 64-52-4-68-22-78-41-12-23 22-45 36-20 23 37 65 32 78 17 20-23-1-37-23-41-24-5-49-10-68-20-30-16-43-92 36-105 36-6 79 5 96 32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommSkype);
export default __webpack_public_path__ + "static/media/comm_skype.7f924cd3acef65c7c3b3da4c13e66b3a.svg";
export { ForwardRef as ReactComponent };